import { ENV } from 'src/environments/environment';

export const API_URL =
  ENV === 'production'
    ? 'https://ontask.herokuapp.com/api/'
    : ENV === 'demo'
    ? 'https://ontask-demo.herokuapp.com/api/'
    : 'http://localhost:3000/api/';
export const OAUTH_ID = '399478053676-q0glhm7j5n3c995s1gehgvns5j8lpj87.apps.googleusercontent.com';
